import axiosClient from "./axiosClient.jsx";
import { utils } from "../../utils/Utils.jsx";
import { reportHttpError } from "../../utils/errorReporter";

let responseInterceptorId = null;
let isHandlingUnauthorized = false;
let interceptorGeneration = 0;

export const setupAuthInterceptor = (props, setConfig, setToken) => {
  if (responseInterceptorId !== null) return;

  interceptorGeneration += 1;
  const currentGeneration = interceptorGeneration;
  isHandlingUnauthorized = false;

  responseInterceptorId = axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (currentGeneration !== interceptorGeneration) {
        return Promise.reject(error);
      }

      const status = error?.response?.status;

      console.log("Response error status", status);
      if ((status === 401 || status === 403) && !isHandlingUnauthorized) {
        console.log("Unauthorized response detected, clearing session...");
        isHandlingUnauthorized = true;
        utils.clearSession(props, setConfig, setToken);
      }

      /* Telemetry: report 5xx + transport failures so backend can
         see when the API is degrading from the client's perspective.
         The reporter itself filters out anything < 500 and the
         /telemetry/* endpoint to avoid recursion. */
      try {
        const url = error?.config?.url || "";
        if (!url.includes("/telemetry/")) {
          reportHttpError(error);
        }
      } catch (_) { /* never let telemetry break user flows */ }

      return Promise.reject(error);
    },
  );
};

export const ejectAuthInterceptor = () => {
  console.log("Ejecting auth interceptor");
  interceptorGeneration += 1;
  if (responseInterceptorId !== null) {
    axiosClient.interceptors.response.eject(responseInterceptorId);
    responseInterceptorId = null;
  }

  isHandlingUnauthorized = false;
};
